const WHY_CHOOSE_US: string[] = [
  'Experienced cleaner',
  'Flexible scheduling',
  'Satisfaction guarantee',
  'Peace of mind',
];

/**
 * The legacy site's "Why choose us?" points — labels only. The legacy
 * landing page never paired these with body copy, so none is invented here.
 * Two columns on mobile, four on desktop, with the same hairline-divider
 * language used elsewhere on the site (a top divider on the grid, verticals
 * between columns, plus a row divider on the mobile 2x2 layout).
 */
export const WhyChooseUs = () => (
  <div className="border-line mt-[38px] grid grid-cols-2 border-t md:grid-cols-4">
    {WHY_CHOOSE_US.map((label, index) => (
      <div
        key={label}
        className={`border-line py-[22px] md:py-6 md:pr-7 md:pl-7 ${
          index % 2 === 1 ? 'border-line border-l pl-3.5' : 'pr-3.5'
        } ${index >= 2 ? 'border-t' : ''} md:border-t-0 ${
          index === 0 ? 'md:border-l-0 md:pl-0' : 'md:border-l'
        }`}
      >
        <div className="font-display text-[19px]">{label}</div>
      </div>
    ))}
  </div>
);
